import axios from 'axios';
// routes
import { paths } from 'src/routes/paths';
// config
import { SALES_RUSH_API } from 'src/config-global';
// auth
import { STORAGE_KEY, isValidToken } from 'src/auth/context/jwt/utils';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: SALES_RUSH_API });

const redirectToLogin = () => {
  window.location.href = paths.auth.login;
};

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(STORAGE_KEY);
    if (!accessToken) {
      return config;
    }
    if (!isValidToken(accessToken)) {
      localStorage.removeItem(STORAGE_KEY);
      delete axiosInstance.defaults.headers.common.Authorization;
      redirectToLogin();
      return Promise.reject(new Error('Session expired'));
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const endpoints = {
  auth: {
    me: '/api/auth/me',
    login: '/v1/auth/admin-phone-login',
    validateOTP: '/v1/auth/admin-validate-otp',
    register: '/v1/auth/admin-register',
    resendOTP: '/v1/auth/admin-resend-otp',
    freeSendOTP: '/v1/auth/free-send-otp',
    freeValidateOTP: '/v1/auth/free-validate-otp',
  },
  users: {
    root: '/v1/users',
  },
  user_gallery: {
    root: '/v1/user-gallery',
  },
  user_reviews: {
    root: '/v1/user-reviews',
  },
  user_blogs: {
    root: '/v1/user-blogs',
  },
  user_blog_seo_tags: {
    root: '/v1/user-blog-seo-tags',
  },
  user_landing_pages: {
    root: '/v1/user-landing-pages',
  },
  user_landing_pages_questions: {
    root: '/v1/user-landing-pages-questions',
  },
  system_landing_pages: {
    root: '/v1/system-landing-pages',
  },
  system_landing_pages_questions: {
    root: '/v1/system-landing-pages-questions',
  },
  user_fields: {
    root: '/v1/user-fields',
  },
  system_fields: {
    root: '/v1/system-fields',
  },
  user_crm_pipelines: {
    root: '/v1/user-crm-pipelines',
  },
  system_crm_pipelines: {
    root: '/v1/system-crm-pipelines',
  },
  user_teams: {
    root: '/v1/user-teams',
  },
  user_permission_sets: {
    root: '/v1/user-permission-sets',
  },
  system_layouts: {
    root: '/v1/system-layouts',
  },
  crm_records: {
    root: '/v1/crm-records',
  },
  crm_tags: {
    root: '/v1/crm-tags',
  },
  user_data_grid_layouts: {
    root: '/v1/user-data-grid-layouts',
  },
  user_quick_list: {
    root: '/v1/user-quick-list',
  },
  user_layouts: {
    root: '/v1/user-layouts',
  },
  crm_interaction_definitions: {
    root: '/v1/crm-interaction-definitions',
  },
  crm_activity: {
    root: '/v1/crm-activity',
  },
  stripe: {
    root: '/v1/stripe',
  },
  user_reporting: {
    root: '/v1/user-reporting',
  },
  user_home_preferences: {
    root: '/v1/user-home-preferences',
  },
  user_aging_records: {
    root: '/v1/user-aging-records',
  },
  user_ipeline_snapshots: {
    root: '/v1/user-pipeline-snapshots',
  },
  user_landing_pages_features: {
    root: '/v1/user-landing-pages-features',
  },
  system_internal_icons: {
    root: '/v1/system-internal-icons',
  },
  system_landing_pages_features: {
    root: '/v1/system-landing-pages-features',
  },
  websites: {
    root: '/v1/webfinder-user-sites',
  },
  system_website_templates: {
    root: '/v1/system-website-templates',
  },
  recent_record_views: {
    root: '/v1/recent-record-views',
  },
  data_import: {
    root: '/v1/data-import',
  },
  scheduled_actions: {
    root: '/v1/scheduled-actions',
  },
  record_intelligence: {
    root: '/v1/record-intelligence',
  },
  recommended_actions: {
    root: '/v1/recommended-actions',
  },
};
